"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultIpnsGateways = exports.defaultIpfsGateways = void 0;
const defaultIpfsGateways = [
    "https://ipfs.io",
    "https://gateway.ipfs.io",
    "https://gateway.pinata.cloud",
    "https://cloudflare-ipfs.com",
    "https://4everland.io",
    "https://w3s.link",
    "https://dweb.link",
    "https://w3s.link"
];
exports.defaultIpfsGateways = defaultIpfsGateways;
const defaultIpnsGateways = [
    "https://ipfs.io",
];
exports.defaultIpnsGateways = defaultIpnsGateways;
//# sourceMappingURL=defaultGateways.js.map